import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "@/components/ui/dialog";
import { Info } from "lucide-react";

/**
 * Phase 11.5 — per-calculator "How this works" transparency modal.
 * NAIC/NAIC-aligned educational disclaimer + methodology + assumptions.
 */
export const CalcHowItWorksModal = ({
  calcName,
  methodology,
  assumptions = [],
  limitations = [],
  triggerClassName = "",
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid={`calc-howitworks-trigger-${calcName.replace(/\s+/g, "-").toLowerCase()}`}
          className={`inline-flex items-center gap-1.5 text-xs font-medium text-lw-navy/70 hover:text-lw-navy transition-colors ${triggerClassName}`}
        >
          <Info size={14} /> How this works
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-xl text-lw-navy">
            How the {calcName} works
          </DialogTitle>
          <DialogDescription className="text-xs text-lw-muted">
            Educational estimate only — not a guarantee of future results,
            benefits, or rates.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-5 pt-2 text-sm text-lw-ink">
          <div>
            <div className="font-sans-ui text-[0.68rem] tracking-[0.2em] uppercase text-lw-gold mb-2">
              Methodology
            </div>
            <p className="leading-relaxed text-lw-muted">{methodology}</p>
          </div>
          {assumptions.length > 0 && (
            <div>
              <div className="font-sans-ui text-[0.68rem] tracking-[0.2em] uppercase text-lw-gold mb-2">
                Key assumptions
              </div>
              <ul className="list-disc pl-5 space-y-1.5 text-lw-muted leading-relaxed">
                {assumptions.map((a, i) => (
                  <li key={i}>{a}</li>
                ))}
              </ul>
            </div>
          )}
          {limitations.length > 0 && (
            <div>
              <div className="font-sans-ui text-[0.68rem] tracking-[0.2em] uppercase text-lw-gold mb-2">
                Limitations
              </div>
              <ul className="list-disc pl-5 space-y-1.5 text-lw-muted leading-relaxed">
                {limitations.map((a, i) => (
                  <li key={i}>{a}</li>
                ))}
              </ul>
            </div>
          )}
          <div className="rounded-lg bg-lw-ivory-warm border border-lw-navy/10 p-3.5 text-xs text-lw-muted leading-relaxed">
            This tool is for educational purposes only and is not tax, legal,
            investment, or financial advice. Insurance and annuity guarantees
            are backed by the financial strength and claims-paying ability of
            the issuing carrier. Product availability and underwriting
            outcomes vary by state and carrier. Consult a qualified
            professional regarding your specific situation.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalcHowItWorksModal;
